<script setup lang="ts">
const props = defineProps<{
    isOverview: boolean
    title: string
    image?: string
}>()

const emit = defineEmits<{
    (e: "close"): void
    (e: "go-back"): void
}>()

const close = () => {
    emit("close")
}

const goBack = () => {
    emit("go-back")
}
</script>

<template>
    <header class="sportmatch-widget-panel-header">
        <h3 class="sportmatch-widget-panel-header-content" v-if="isOverview">
            {{ title }}
        </h3>
        <div class="sportmatch-widget-panel-header-content" v-else @click="goBack">
            <span class="icon-chevron-left"></span>
            <h3>Terug</h3>
        </div>
        <img v-if="image" class="sportmatch-widget-panel-header-image" :src="image" alt="">
        <button type="button" @click="close" class="sportmatch-widget-close-button" aria-label="Sluit widget">
            <span class="icon-close" aria-hidden="true"></span>
        </button>
    </header>
</template>
